import { hasCanvasKeyboardOwningOverlay } from './hasCanvasKeyboardOwningOverlay';
import { shouldIgnoreCanvasDeleteShortcut } from './shouldIgnoreCanvasDeleteShortcut';

/** xyflow root class — chat is a sibling overlay, not inside this node. */
const REACT_FLOW_ROOT_CLASS = 'react-flow';

const originatedOnReactFlow = (event: KeyboardEvent): boolean =>
  typeof event.composedPath === 'function' &&
  event.composedPath().some((node) => node instanceof Element && node.classList.contains(REACT_FLOW_ROOT_CLASS));

/**
 * Apply only when the key originated on the xyflow root. After a null-state insert
 * the image stays selected; a body/chat Backspace would otherwise empty the canvas
 * and restore the hero. Box-select focuses a selected node on mouseup so that
 * Delete still has a `.react-flow` ancestor. Overlays and chat/editables still deny.
 */
export const shouldApplyCanvasDeleteShortcut = (event: KeyboardEvent): boolean =>
  !event.defaultPrevented &&
  originatedOnReactFlow(event) &&
  !hasCanvasKeyboardOwningOverlay() &&
  !shouldIgnoreCanvasDeleteShortcut(event);
